import { getSalesMetros } from './GetSalesMetros';

/**
 * Sales Metros Service
 * Provides business logic layer for sales metro operations
 */
export const SalesMetrosService = {
  getSalesMetros,
};
